@if (pageReady) {
    <div class="detail-page-action-bar">
        <button class="btn btn-raised" (click)="save()">
            <i class="fas fa-save" aria-hidden="true"></i>
            <span class="d-none d-lg-inline ms-2">{{ "periodicDetail.saveButton" | t }}</span>
        </button>
        @if (id > 0) {
            <button class="btn btn-raised red" (click)="deleteClick()">
                <i class="fas fa-trash"></i>
                <span>{{ "periodicDetail.deleteButton" | t }}</span>
            </button>
        }
    </div>

    <div class="detail-page-card" [formGroup]="form">
        <div class="detail-page-card-title">
            {{ "periodicDetail.editPeriodicTitle" | t }}
        </div>
        <div class="detail-page-card-body padded form-group-styling invite-compose-area">
            <div class="form-group">
                <cerrix-textfield
                    [fieldLabel]="'periodicDetail.nameLabel' | t"
                    formControlName="name"
                    name="notification-name"
                    dataUiid="periodic-detail-moi-name"
                    [required]="true"
                    [placeholder]="'periodicDetail.requiredPlaceholder' | t"
                ></cerrix-textfield>
            </div>
            <div class="form-group">
                <cerrix-checkbox
                    fontsize="0.9em"
                    [label]="'periodicDetail.activeLabel' | t"
                    data-uiid="periodic-detail-moi-active"
                    formControlName="active"
                ></cerrix-checkbox>
            </div>
            <div class="form-group">
                <label>{{ "periodicDetail.periodLabel" | t }}</label>
                <ng-select
                    id="periodSelect"
                    name="periodSelect"
                    [items]="periods"
                    bindLabel="Name"
                    bindValue="ID"
                    [multiple]="false"
                    formControlName="period"
                    [placeholder]="'periodicDetail.requiredPlaceholder' | t"
                    (change)="setDayNumbers($event)"
                ></ng-select>
            </div>
            <div class="form-group">
                <label
                    >{{ "periodicDetail.dayLabel" | t }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'periodicDetail.dayTooltip' | t"
                        matTooltipClass="breakable-tooltip"
                    ></i>
                </label>
                <ng-select
                    id="dayNumberSelect"
                    name="dayNumberSelect"
                    [items]="dayNumbers"
                    [readonly]="!notification.period"
                    bindLabel="Name"
                    bindValue="ID"
                    [multiple]="false"
                    formControlName="dayNumber"
                    [placeholder]="'periodicDetail.requiredPlaceholder' | t"
                ></ng-select>
            </div>
            <div class="form-group">
                <label>
                    {{ "periodicDetail.organizationLabel" | t }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'periodicDetail.organizationTooltip' | t"
                    ></i>
                </label>
                <cerrix-select-tree
                    class="fullWidth"
                    [getDataMethod]="organizationRequest"
                    formControlName="organizations"
                    [multiselect]="true"
                ></cerrix-select-tree>
            </div>
            <div class="form-group">
                <label
                    >{{ "periodicDetail.moiTypeLabel" | t }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'periodicDetail.moiTypeTooltip' | t"
                    ></i>
                </label>
                <ng-select
                    id="moiTypeSelect"
                    name="moiTypeSelect"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [items]="moiTypes"
                    bindLabel="Name"
                    bindValue="ID"
                    formControlName="moiTypeIds"
                    [placeholder]="'periodicDetail.allPlaceholder' | t"
                ></ng-select>
            </div>
            <div class="form-group">
                <label
                    >{{ "periodicDetail.userTypeLabel" | t }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'periodicDetail.userTypeTooltip' | t"
                    ></i>
                </label>
                <ng-select
                    id="userTypeSelect"
                    name="userTypeSelect"
                    [multiple]="true"
                    [closeOnSelect]="false"
                    [items]="userTypes"
                    bindLabel="Name"
                    bindValue="ID"
                    formControlName="userTypeIds"
                    [placeholder]="'periodicDetail.allPlaceholder' | t"
                >
                </ng-select>
            </div>
            <div class="form-group">
                <label>
                    {{ "periodicDetail.priorityLabel" | t }}
                    <i
                        class="fas fa-question-circle"
                        [matTooltip]="'periodicDetail.priorityTooltip' | t"
                    ></i>
                </label>
                <ng-select
                    id="prioritySelect"
                    name="prioritySelect"
                    [items]="priorities"
                    bindLabel="Name"
                    [closeOnSelect]="false"
                    bindValue="ID"
                    [multiple]="true"
                    formControlName="priorityIds"
                    [placeholder]="'periodicDetail.anyPlaceholder' | t"
                ></ng-select>
            </div>

            <div class="form-group">
                <cerrix-textfield
                    [fieldLabel]="'periodicDetail.messageLabel' | t"
                    formControlName="subject"
                    name="notification-subject"
                    dataUiid="periodic-detail-moi-subject"
                    [required]="true"
                    [placeholder]="'periodicDetail.requiredPlaceholder' | t"
                    (click)="setFocusToSubject()"
                ></cerrix-textfield>
                @for (keyword of keywords; track keyword) {
                    <button class="keyword-button" (click)="addKeyword(keyword)">
                        {{ keyword }}
                    </button>
                }
                <cerrix-editor
                    [class.cerrixEditor]="isEmpty"
                    [value]="notification.message"
                    [allowPdfEmbed]="false"
                    (valueChange)="onChange($event)"
                    (click)="deFocusSubject()"
                    #editor
                ></cerrix-editor>
            </div>
        </div>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
